import React from "react";
import { Link, useLocation } from "react-router-dom";
import profile from "../../../images/log-veezzo-login.jpeg";
import { Dropdown } from "react-bootstrap";
import LogoutPage from './Logout';

const Header = ({ onNote }) => {
  const location = useLocation();
  
  var path = window.location.pathname.split("/");
  var name = path[path.length - 1].split("-");
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName.includes("app")
    ? filterName.filter((f) => f !== "app")
    : filterName.includes("ui")
    ? filterName.filter((f) => f !== "ui")
    : filterName.includes("uc")
    ? filterName.filter((f) => f !== "uc")
    : filterName.includes("basic")
    ? filterName.filter((f) => f !== "basic")
    : filterName.includes("jquery")
    ? filterName.filter((f) => f !== "jquery")
    : filterName.includes("table")
    ? filterName.filter((f) => f !== "table")
    : filterName.includes("page")
    ? filterName.filter((f) => f !== "page")
    : filterName.includes("email")
    ? filterName.filter((f) => f !== "email")
    : filterName.includes("ecom")
    ? filterName.filter((f) => f !== "ecom")
    : filterName.includes("chart")
    ? filterName.filter((f) => f !== "chart")
    : filterName.includes("editor")
    ? filterName.filter((f) => f !== "editor")
    : filterName;

  // Determine the title to display
  let displayTitle = finalName.join(" ");
  if (displayTitle.length === 0 || displayTitle === "dashboard dark") {
    displayTitle = location.pathname === "/pos" ? "POS" : "Dashboard";
  }

  return (
    <>
      <div className="header">
        <div className="header-content">
          {/* Left side - Dashboard title */}
          {/* <div className="header-left"> */}
            <div className="dashboard_bar" style={{ textTransform: "capitalize" }}>
              {displayTitle}
            </div>
          {/* </div> */}

          {/* Right side - Profile dropdown - hidden on POS */}
          {location.pathname !== "/pos" && (
            <ul className="navbar-nav header-right">
              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
                  <img 
                    src={profile} 
                    width={40} 
                    height={40} 
                    alt="" 
                    className="rounded-circle" 
                  />
                </Dropdown.Toggle>
                
                <Dropdown.Menu align="right" className="mt-2 dropdown-menu dropdown-menu-end">
                  {(() => {
                    const role = localStorage.getItem("role");
                    if (role === "shopadmin" || role === "shopmanager") {
                      return (
                        <Link to="/shop-vendor-profile" className="dropdown-item ai-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg" 
                            className="text-primary me-1"
                            width={18} 
                            height={18} 
                            viewBox="0 0 24 24" 
                            fill="none"
                            stroke="currentColor" 
                            strokeWidth={2} 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx={12} cy={7} r={4} />
                          </svg>
                          <span className="ms-2">Profile</span>
                        </Link>
                      );
                    } else if (role === "cityadmin" || role === "citymanager") {
                      return (
                        <Link to="/city-admin-profile" className="dropdown-item ai-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg" 
                            className="text-primary me-1"
                            width={18} 
                            height={18} 
                            viewBox="0 0 24 24" 
                            fill="none"
                            stroke="currentColor" 
                            strokeWidth={2} 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                          >
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                            <circle cx={12} cy={7} r={4} />
                          </svg>
                          <span className="ms-2">Profile</span>
                        </Link>
                      );
                    }
                    return null;
                  })()}

                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          )}
        </div>
      </div>

      <style>{`
        .header {
          position: fixed !important;
          top: 0 !important;
          right: 0 !important;
          left: 70px !important;
          width: calc(100% - 70px) !important;
          height: 60px !important;
          background: #ffffff !important;
          z-index: 1000 !important;
          transition: left 0.5s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: none !important;
          border-bottom: none !important;
          display: flex !important;
          align-items:  !important;
        }

        #main-wrapper.sidebar-expanded .header {
          left: 330px !important;
        }

        .header-content {
          width: 150% !important;
          height: 100% !important;
          padding: 0 10px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
        }

        .header-left {
          flex: 0 0 auto !important;
          display: flex !important;
          align-items: center !important;
          height: 100% !important;
        }

        .dashboard_bar {
          font-size: 24px !important;
          font-weight: 700 !important;
          color: #1a1d29 !important;
          margin: 0 !important;
          padding: 0 !important;
          white-space: nowrap !important;
          text-align: left !important;
        }

        .header-right {
          display: flex !important;
         
          margin: 0 !important;
          padding: 0 !important;
          list-style: none !important;
        }

        .header-profile .nav-link {
          padding: 0 5px !important;
          display: flex !important;
          align-items: center !important;
          cursor: pointer !important;
          margin: 0 !important;
        }

        .header-profile img {
          object-fit: cover !important;
          border: 2px solid #BA0F30  !important;
          cursor: pointer !important;
        }

        /* Content body spacing */
        .content-body {
          margin-left: 70px !important;
          margin-top: 20px !important;
          padding: 20px !important;
          transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          min-height: calc(100vh - 60px) !important;
        }

        #main-wrapper.sidebar-expanded .content-body {
          margin-left: 330px !important;
        }
      `}</style>
    </>
  );
};

export default Header;